import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-provi-teacher-report',
  templateUrl: './provi-teacher-report.component.html',
  styleUrls: ['./provi-teacher-report.component.scss']
})
export class ProviTeacherReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
